module.exports = __webpack_public_path__ + "static/img/salesHome_difficulties_1.537ea36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/salesHome_difficulties_1.svg
// module id = onyb
// module chunks = 1